import { TCountry, TIcon } from "@/api/v1_0";

export namespace Bank {
  interface IBank {
    value: Array<string>;
    label: string;
    icon: TIcon;
  }

  type IBanks = {
    [key in TCountry]: Array<IBank>;
  };

  const _banks: IBanks = {
    RUS: [
      {
        value: ["akbars", "акбарс", "ак барс"],
        label: "Ак Барс Банк",
        icon: TIcon.Akbars,
      },
      {
        value: ["alfabank", "альфабанк"],
        label: "Альфа-банк",
        icon: TIcon.Alfabank,
      },
      {
        value: ["atb", "атб", "азиатско тихоокеанский банк"],
        label: "Азиатско-Тихоокеанский Банк",
        icon: TIcon.Atb,
      },
      {
        value: ["citibank", "ситибанк"],
        label: "Банк Ситибанк",
        icon: TIcon.CitiBank,
      },
      { value: ["домрф", "дом.рф"], label: "ДОМ.РФ", icon: TIcon.Domrf },
      {
        value: ["gazprom", "газпромбанк"],
        label: "Газпромбанк",
        icon: TIcon.Gazprom,
      },
      {
        value: ["home credit", "хоумкредит"],
        label: "Банк Хоум Кредит",
        icon: TIcon.HomeCredit,
      },
      {
        value: ["mkb", "мкб", "московский кредитный банк"],
        label: "Московский кредитный банк",
        icon: TIcon.Mkb,
      },
      { value: ["mts", "мтс"], label: "МТС Банк", icon: TIcon.Mts },
      {
        value: ["otkritie", "открытие"],
        label: "Банк Открытие",
        icon: TIcon.Otkritie,
      },
      { value: ["otp", "отп банк"], label: "ОТП Банк", icon: TIcon.Otp },
      { value: ["paypal", "пайпал"], label: "Paypal", icon: TIcon.Paypal },
      {
        value: ["pochtabank", "почта банк"],
        label: "Почта Банк",
        icon: TIcon.PochtaBank,
      },
      {
        value: ["psbank", "псб", "промсвязьбанк"],
        label: "Промсвязьбанк",
        icon: TIcon.Psbank,
      },
      { value: ["qiwi", "киви банк"], label: "QIWI Банк", icon: TIcon.Qiwi },
      {
        value: ["raiffeisenbank", "райффайзенбанк"],
        label: "Райффайзенбанк",
        icon: TIcon.Raiffeisenbank,
      },
      {
        value: ["rnkb", "рнкб", "российский национальный коммерческий банк"],
        label: "Российский национальный коммерческий банк",
        icon: TIcon.Rnkb,
      },
      { value: ["rosbank", "росбанк"], label: "Росбанк", icon: TIcon.Rosbank },
      {
        value: ["rosgosstrakh bank", "росгосстрах банк", "ргс банк"],
        label: "Росгосстрах Банк",
        icon: TIcon.RosgosstrakhBank,
      },
      {
        value: [
          "russkiy standart",
          "русский стандарт",
          "банк русский стандарт",
        ],
        label: "Банк Русский Стандарт",
        icon: TIcon.RusskiyStandart,
      },
      {
        value: ["sberbank", "сбербанк"],
        label: "СберБанк",
        icon: TIcon.Sberbank,
      },
      { value: ["skb", "скб банк"], label: "СКБ-Банк", icon: TIcon.Skb },
      {
        value: ["sovcombank", "совкомбанк"],
        label: "Совкомбанк",
        icon: TIcon.Sovcombank,
      },
      {
        value: ["tinkoff", "тинькофф", "тиньков"],
        label: "Тинькофф",
        icon: TIcon.Tinkoff,
      },
      { value: ["tochka", "точка"], label: "Точка", icon: TIcon.Tochka },
      { value: ["ubrd", "убрир"], label: "УБРиР", icon: TIcon.Ubrd },
      {
        value: ["unikredit", "юникредит банк", "юни кредит банк"],
        label: "ЮниКредит Банк",
        icon: TIcon.Unikredit,
      },
      {
        value: ["uralsib", "уралсиб"],
        label: "Банк Уралсиб",
        icon: TIcon.Uralsib,
      },
      {
        value: ["vostochniy", "восточный", "банк восточный"],
        label: 'Банк "Восточный"',
        icon: TIcon.Vostochniy,
      },
      { value: ["vtb", "втб", "банк втб"], label: "Банк ВТБ", icon: TIcon.Vtb },
      {
        value: ["yoomoney", "юmoney", "юмани"],
        label: "YooMoney",
        icon: TIcon.Yoomoney,
      },
    ],
  };

  export const banks = (country: TCountry): Array<IBank> =>
    _banks[country] || [];
}
